<template>
  <!-- 商城侧边栏BEGIN -->
  <div class="top-box" id="topNav" v-cloak>
    <div class="top-nav swiper-container" :class="{'swiper-no-swiping': itemList.length <= 6}">
      <div class="swiper-wrapper">
        <template v-for="(item,index) in itemList">
          <div class="swiper-slide top-nav-item" :key="index" @click="itemClick(item)" v-if="item.custom === 'try-back-list' && !isListPage">
            <img class="top-nav-item-img" :src="item.img + '?x-oss-process=image/resize,w_160,m_lfit'"/>
          </div>
          <div class="swiper-slide top-nav-item" :key="index" @click="itemClick(item)" v-else-if="item.custom !== 'try-back-list'">
            <img class="top-nav-item-img" :src="item.img + '?x-oss-process=image/resize,w_160,m_lfit'"/>
          </div>
        </template>
      </div>
    </div>
    <div v-show="itemList.length > 6">
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <div class="iphonxblock" style="background-color: white;"></div>
  </div>
  <!-- 商城侧边栏END -->
</template>

<script>
import Swiper from "swiper";
import "../../node_modules/swiper/dist/css/swiper.css";
export default {
  name: "sideBar",
  data() {
    return {
      // 导航列表
      itemList: '',
      // 是否是列表页
      isListPage: true,
    };
  },
  watch: {
    '$route': 'getPath'
  },

  mounted() {
    this.getSidebarData();
    this.initSwiper();
    this.setupScrollBehavior('#topNav');
  },
  methods: {
    // 获取侧边栏数据
    getSidebarData: function () {
      var _this = this;
      var info = {
        platform: 'try',
        type: 'wap'
      }
      common.getJson(solution_host + '/api/shop/sidebar', info, function (res) {
        console.log(res);
        _this.itemList = res.data.items;
      });
    },
    getPath(e) {
      // 判断是不是列表页 列表页没有返回列表页按钮
      this.isListPage = e.path === '/home';
      console.log(12131313131, this.isListPage)
    },
    // swiper 初始化
    initSwiper: function () {
      var _this = this;
      this.$nextTick(function () {
        _this.mySwiper = new Swiper('#topNav .swiper-container', {
          autoplay: false,
          centerInsufficientSlides: true,
          // 显示6个
          slidesPerView: 6,
          // 默认显示第一个
          initialSlide: 1,
          // 父级修改了宽度，子级也跟着修改
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: '#topNav .swiper-button-next',
            prevEl: '#topNav .swiper-button-prev',
          },
        });
        setTimeout(function () {
          if ($('#topNav .swiper-container').length) _this.mySwiper.slideTo(0, 10, false); //切换到第一个slide，速度为1秒
        }, 0)
      })
    },

    // 点击
    itemClick: function (item) {
      if (item.tag) {
        gioTrackAction(item.tag, {
          'iconname': item.title
        });
      }
      switch (item.custom) {
        case 'url':
          common.gotoUrl(item.url);
          break;
        case 'gzh':
          this.$dialog.show(document.querySelector('.dialog-box.gzh-dialog'));
          break;
        case 'try-back-list':
          this.$router.push({
            path: '/'
          });
          break;
      }
    },

    // 判断上划下滑 显示隐藏副导航
    setupScrollBehavior: function (subNavSelector) {
      var lastScrollPosition = 0;
      // 监听滚动事件
      window.addEventListener('scroll', () => {
        // 获取导航栏元素
        var header = document.querySelector(subNavSelector);
        if(!header) return;
        const currentScrollPosition = window.scrollY;

        // 窗口高度
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        // 页面高度
        var documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        // 滚动条位置
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        if (currentScrollPosition > lastScrollPosition) {
          // 下滑时隐藏导航
          header.style.display = 'none';
        } else {
          // 上划时显示导航
          header.style.display = 'block';
        }

        // 到达顶部或底部时显示导航
        if (scrollTop <= 0 || (windowHeight + scrollTop + 2) >= documentHeight) {
          header.style.display = 'block';
        }

        lastScrollPosition = currentScrollPosition;
      });
    },
  }


}
</script>

<style lang="scss" scoped>
.top-box {
  position: fixed;
  bottom: 0;
  z-index: 9;
  width: 100%;
  height: 1.39rem;
  padding: 0 .4rem;
  background-image: url("~@/assets/aside-nav/navbg_t.png");
  background-size: 100%;
  background-position: center center;

  .top-nav {
    width: 100%;
    height: 1.39rem;
    box-shadow: none;

    .top-nav-item {
      display: flex;
      align-items: center;
      .top-nav-item-img {
        width: auto;
        height: .95rem;
      }
    }
  }

  .swiper-button-prev, .swiper-button-next {
    top: 1rem;
    width: .3rem;
    height: .3rem;
  }

  .swiper-button-prev {
    left: 5px;
    background: url("/static/mobile/images/icon-top-nav-left.png") no-repeat center center / .2rem;
  }

  .swiper-button-next {
    right: 5px;
    background: url("/static/mobile/images/icon-top-nav-right.png") no-repeat center center / .2rem;
  }
}
//适配iPhonx
.iphonxblock {
  width: 100%;
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
}
</style>
